<template>
  <v-menu bottom origin="center center" transition="scale-transition">
    <template v-slot:activator="{ on }">
      <v-btn
        v-if="value && value.length > 0"
        icon
        color="primary"
        dark
        v-on="on"
        :disabled="loading"
      >
        <v-icon>mdi-menu</v-icon>
      </v-btn>
    </template>

    <v-list>
      <div v-for="(action, i) in value" :key="i">
        <v-list-item v-if="action.allow" @click="action.handle(item)">
          <v-list-item-icon>
            <v-icon v-text="action.icon"></v-icon>
          </v-list-item-icon>
          <v-list-item-title>{{ action.text }}</v-list-item-title>
        </v-list-item>
      </div>
    </v-list>
  </v-menu>
</template>

<script>
export default {
  props: {
    value: {
      default: () => {
        return [];
      }
    },
    item: {},

    loading: {
      default: () => {
        return false;
      }
    }
  },
  methods: {
    async accessAllowed(access) {
      if (!access) return true;
      return await this.$auth.claimExist(access);
    }
  },
  async mounted() {
    await this.value.forEach(async a => {
      a.allow = a.access ? await this.accessAllowed(a.access) : true;
          this.$forceUpdate();
    });

  }
};
</script>